import React from "react";

const QuranSurahOverlay = ({
  isOpen,
  usePopupLayout,
  uiLanguage,
  uiLabels,
  chapters,
  currentChapterIdOnPage,
  onClose,
  onSelectSurah,
  registerItemRef,
}) => {
  if (!isOpen) {
    return null;
  }

  const isArabic = uiLanguage === "ar";
  const overlayClassName = usePopupLayout
    ? "quran-surah-overlay quran-surah-overlay--popup"
    : "quran-surah-overlay";
  const content = (
    <>
      <div className={`quran-surah-overlay-head ${isArabic ? "quran-overlay-head--rtl" : "quran-overlay-head--ltr"}`}>
        <div className="quran-surah-overlay-title">{uiLabels.chapterListTitle}</div>
        <button
          type="button"
          className="quran-overlay-close-btn quran-surah-overlay-close"
          aria-label={uiLabels.close}
          title={uiLabels.close}
          onClick={onClose}
        >
          {uiLabels.close}
        </button>
      </div>

      <div className="quran-surah-overlay-list">
        {(chapters || []).map((chapter) => {
          const firstPage = Number(chapter?.pages?.[0]) || "-";
          const versesCount = Number(chapter?.versesCount) || "-";

          return (
            <button
              key={`overlay-chapter-${chapter.id}`}
              type="button"
              className={`quran-surah-overlay-item ${
                Number(currentChapterIdOnPage) === Number(chapter.id)
                  ? "quran-surah-overlay-item--active"
                  : ""
              }`}
              ref={(node) => registerItemRef(chapter.id, node)}
              onClick={() => onSelectSurah(chapter.id)}
            >
              <span className="quran-surah-overlay-index">{chapter.id}</span>
              <span className="quran-surah-overlay-texts">
                <span className="quran-surah-overlay-name">{chapter.name}</span>
                <span className="quran-surah-overlay-meta">{uiLabels.pageWord} {firstPage} - {versesCount} {uiLabels.ayahWord}</span>
              </span>
            </button>
          );
        })}
      </div>
    </>
  );

  return (
    <div
      className={overlayClassName}
      dir={isArabic ? "rtl" : "ltr"}
      onClick={usePopupLayout ? onClose : (event) => event.stopPropagation()}
      onPointerUp={(event) => event.stopPropagation()}
    >
      {usePopupLayout ? (
        <div
          className="quran-surah-panel"
          onClick={(event) => event.stopPropagation()}
          onPointerUp={(event) => event.stopPropagation()}
        >
          {content}
        </div>
      ) : (
        content
      )}
    </div>
  );
};

export default QuranSurahOverlay;
